/** The Resume page's route. */
export const RESUME_PATH = '/resume'

/**
 * A login that brings the browser back to the Resume page, which then restores this tab's own
 * place. Every Resume-page login uses it, so whichever login completes, the tab lands back there.
 */
export const RESUME_LOGIN_URL = `/api/auth/sso/login?to=${encodeURIComponent(RESUME_PATH)}`

/**
 * {@link RESUME_LOGIN_URL}, asking Cognito for the page's language. Cognito's managed login takes
 * the base language (`ja`, not `ja-JP`), except Brazilian Portuguese, which stays `pt-BR`.
 */
export function resumeLoginUrl(language: string | undefined): string {
  if (!language) {
    return RESUME_LOGIN_URL
  }
  const lang = language.toLowerCase().startsWith('pt') ? 'pt-BR' : language.split('-')[0]
  return `${RESUME_LOGIN_URL}&lang=${encodeURIComponent(lang)}`
}
